import dayjs from 'dayjs';
import { Model } from './model';
import { TransformStringToDayJS } from './utils';

export class UserInvite extends Model {
  email: string;

  as_admin: boolean;

  @TransformStringToDayJS()
  sent_at: dayjs.Dayjs;
}
